import React from 'react';
import AutoSaveTextInput from 'components/forms/AutoSaveFormFields/AutoSaveTextInput';
import {isNoU} from 'utils/DBUtils';

/*

Plain text input for a single free-typed id. Persisted as a 0-or-1-element
array (`codeListIds`) to match the backend's array field, even though only
one id is allowed. There is no fetched set of options here - reuses
AutoSaveTextInput so required-field validation/error display works the same
as every other required text field.

*/

const IdListEditor = (props) => (
    <AutoSaveTextInput {...props}
                        defaultValue={!isNoU(props.defaultValue) && props.defaultValue.length > 0 ? props.defaultValue[0] : ''}
                        onValueChanged={(value, field, errors) => props.onValueChanged(value && value.trim() !== '' ? [value.trim()] : [], field, errors)}/>
);

export default IdListEditor;



// WEBPACK FOOTER //
// ./public/components/forms/CustomFields/IdListEditor.jsx